export const WAGMI_WALLETCONNECTOR_APP_NAME = "Blessnet";

export const WAGMI_WALLETCONNECTOR_PROJECT_ID =
  "96489a4b77fb52c8958c636e7b84936f";

//? Required for the walletconnect connector to work with RainbowKit
export const RAINBOW_KIT_PROJECT_ID = "96489a4b77fb52c8958c636e7b84936f";
